import { render } from "./WorkFilter.vue?vue&type=template&id=3f836994"
import script from "./WorkFilter.vue?vue&type=script&lang=js"
export * from "./WorkFilter.vue?vue&type=script&lang=js"

import "./WorkFilter.vue?vue&type=style&index=0&id=3f836994&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__